import { baseApi } from './baseApi';

export interface DiskCapacityStats {
  category: string;
  count: number;
  percentage: number;
}

export interface DashboardMetrics {
  total_devices: number;
  online_devices: number;
  offline_devices: number;
  unverified_devices: number;
  pending_devices: number;
  verified_devices: number;
  rejected_devices: number;
  disk_capacity_stats: DiskCapacityStats[];
  last_updated: string;
}

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardMetrics: builder.query<DashboardMetrics, void>({
      query: () => 'dashboard/metrics',
      providesTags: ['Dashboard'],
    }),
  }),
});

export const {
  useGetDashboardMetricsQuery,
} = dashboardApi;
